<template>
  <div class="footer-wrapper">
    <div class="logo-wrapper" v-if="footerLogo.length">
      <img
        :src="item"
        class="logo-item"
        alt=""
        v-for="(item, index) in footerLogo"
        :key="index"
      />
    </div>
    <div class="copyright-wrapper">
      <div class="copyright">
        Copyright © 2020-{{ new Date().getFullYear() }} 上海源墨健康管理有限公司
        版权所有
      </div>
      <div class="beian" @click="toBeiAn">沪ICP备2020032025号-1</div>
      <div class="benan-logo">
        <img src="../../assets/pc/beian-logo.png" alt="" class="beian-icon" />
        沪公网安备 31010402003588
      </div>
      <!-- <div class="lxr">网站联系人：xxxxxx</div> -->
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import store from "@/store";
const footerLogo = computed(() => {
  const { footerLogo } = store.getters["config/getConfig"];
  const list = footerLogo ? footerLogo.split(",") : [];
  return list;
});

const toBeiAn = () => {
  window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
};
</script>

<style lang="less" scoped>
.footer-wrapper {
  // position: fixed;
  // bottom: 0;
  width: 100%;
  // height: 60px;
  // line-height: 60px;
  padding: 30px 0;
  background: #242529;
  .logo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 60px;
    margin-bottom: 16px;
    .logo-item {
      width: 40px;
      height: 40px;
      border-radius: 8px;
    }
  }
  .copyright-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 45px;
    color: #999;
    font-family: PingFangSC, PingFang SC;
    font-size: 12px;
    .beian {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .benan-logo {
      display: flex;
      align-items: center;
    }
    .beian-icon {
      width: 19px;
      height: 18px;
      margin-right: 8px;
    }
  }
}
</style>
